import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export default function GoogleReviewsSkeleton() {
  return (
    <section className="container-fluid pt-5 bg-white google-reviews-section">
      <div className="container">
        <div className="row align-items-center">
          
          {/* LEFT RATING COLUMN SKELETON */}
          <div className="col-md-3 col-xl-2 mb-4 mb-lg-0 text-center text-lg-start px-0">
            <h3 className="fw-bold mb-2">EXCELLENT</h3>

            {/* Stars Skeleton */}
            <div className="d-flex justify-content-center justify-content-lg-start mb-2">
              <Skeleton width={100} height={20} baseColor="#f1f1f1" highlightColor="#f1ebee" />
            </div>

            {/* Total Reviews Text Skeleton */}
            <p className="small text-muted mb-2">
              Based on <Skeleton width={35} height={16} baseColor="#f1f1f1" highlightColor="#f1ebee" inline={true} /> reviews
            </p>

            {/* Google Logo Placeholder */}
            <div className="mt-1">
              <Skeleton width={100} height={32} baseColor="#f1f1f1" highlightColor="#f1ebee" />
            </div>
          </div>

          {/* RIGHT SWIPER SKELETON */}
          <div className="col-md-9 col-xl-10 px-0 px-md-3">
            <div className="row g-3">
              {[1, 2, 3].map((_, i) => (
                <div key={i} className="col-12 col-md-6 col-xl-4">
                  <div className="h-100 p-2">
                    <div className="card h-100 border-0 shadow-sm rounded-4">
                      <div className="card-body d-flex flex-column p-3">
                        
                        {/* Header */}
                        <div className="d-flex align-items-center mb-2">
                          <div className="me-3">
                            <Skeleton circle width={40} height={40} baseColor="#f1f1f1" highlightColor="#f1ebee" />
                          </div>

                          <div className="flex-grow-1">
                            <div className="mb-1">
                              <Skeleton width={110} height={16} baseColor="#f1f1f1" highlightColor="#f1ebee" />
                            </div>
                            <div className="d-flex mb-1 mt-1">
                              <Skeleton width={80} height={12} baseColor="#f1f1f1" highlightColor="#f1ebee" />
                            </div>
                          </div>

                          <div>
                            <Skeleton width={22} height={22} baseColor="#f1f1f1" highlightColor="#f1ebee" />
                          </div>
                        </div>

                        {/* Relative Time */}
                        <div className="text-gray small mb-2">
                          <Skeleton width={70} height={12} baseColor="#f1f1f1" highlightColor="#f1ebee" />
                        </div>

                        {/* Body Text */}
                        <div className="google-review-text mt-1">
                          <Skeleton count={3} height={12} baseColor="#f1f1f1" highlightColor="#f1ebee" style={{ marginBottom: '6px' }} />
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}